<button
  mat-flat-button
  [color]="'primary'"
  [disabled]="isUploading()"
  (click)="$event.preventDefault(); $event.stopPropagation(); fileInput.click()">
  <div class="column-grid tw-gap-2 tw-place-items-center">
    <span>Upload</span>
    <mat-spinner *ngIf="isUploading();" [diameter]="24"/>
  </div>
</button>
<input #fileInput
       data-cy="doc-upload-input"
       type="file"
       (change)="uploadDocuments($event.target.files)"
       [hidden]="true"
       multiple
       [accept]="typesAccepted"/>
